module.exports = __webpack_public_path__ + "static/media/mito03.a7bc5a57.jpg";